import React from 'react';
import { ViewHtml } from '@common/pages/ViewHtml/ViewHtml';
import useAppNavigation from '../../routing/useAppNavigation';
import { useFetchHtml } from '@common/hooks/useFetchHtml';

interface Props {
  printUrl: string;
}

export const ViewHtmlCustomer = ({ printUrl }: Props) => {
  const { goToSubmissions } = useAppNavigation();

  const handleContinue = () => {
    goToSubmissions();
  };

  const { htmlData } = useFetchHtml();

  return (
    <ViewHtml onContinue={handleContinue} published={false} htmlData={htmlData} showIds={false} printUrl={printUrl} isAdmin={false}></ViewHtml>
  );
};

export const ViewHtmlCustomerPublished = ({ printUrl }: Props) => {
  const { goToSubmissions } = useAppNavigation();

  const handleContinue = () => {
    goToSubmissions();
  };

  return <ViewHtml onContinue={handleContinue} published={true} showIds={false} printUrl={printUrl} isAdmin={false} />;
};
